<div mat-dialog-title class="internet-search-detail-dialog__header">
  DETAIL
  <img class="themified-white-icon internet-search-detail-dialog__close-icon" src="/assets/icons/cross-icon.png" (click)="closeDialog()">
</div>
<div mat-dialog-content class="internet-search-detail-dialog__content">
  <div class="result-item">
    <div class="result-item__label">Summary</div>
    <div class="result-item__value">{{nlpResult?.summary ? nlpResult?.summary : '-'}}</div>
  </div>
  <div class="result-item result-item_multi-values">
    <div class="result-item__label">Top 3 Names Hit</div>
    <div class="result-item__value" *ngIf="!nlpResult?.ner?.allNamesHit?.length">-</div>
    <div class="result-item__value-group-container">
      <ng-container *ngFor="let nameHit of nlpResult?.ner?.allNamesHit | slice:0:3; let i = index">
        <div class="result-item__label">Name Hit #{{i+1}}</div>
        <div class="result-item__value result-item__value_url">
          {{nameHit[0]}} (Confidence {{nameHit[1] * 100 | number: '1.2-2'}}%)
        </div>
      </ng-container>
    </div>
  </div>
  <div class="result-item">
    <div class="result-item__label">Sentiment Class</div>
    <div class="result-item__value">{{nlpResult?.sentiment?.class ? nlpResult?.sentiment?.class : '-'}}</div>
  </div>
  <div class="result-item result-item_scrollable-content">
    <div class="result-item__label">Sentiment Hit Snapshot</div>
    <div class="result-item__value">
      <div class="hit-container">
        <ng-container *ngIf="nlpResult.sentiment.hits.length else noHitsMsg">
          <ng-container *ngFor="let hitSentence of nlpResult.sentiment.hits">
            ...
            <p class="hit-sentence" artemisKeywordHighlighter [keywordList]="hitSentence[1]">{{hitSentence[0]}}</p>
          </ng-container>
          ...
        </ng-container>
        <ng-template #noHitsMsg>
          No Available Snapshot.
        </ng-template>
      </div>
    </div>
  </div>
</div>